import React, { PureComponent } from 'react';
import { bool, func, node } from 'prop-types';

import Modal from './Modal';

export default class SavingModal extends PureComponent {
  static propTypes = {
    isOpen: bool.isRequired,
    onClose: func.isRequired,
    children: node,
  };

  render() {
    const { children, isOpen, onClose } = this.props;
    return (
      <Modal isActive={isOpen} title="" onClose={onClose}>
        <div className="has-text-centered">
          <p style={{ marginBottom: 16 }}>
            {children || 'La modifica è stata salvata con successo'}
          </p>
          <button onClick={onClose} className="button">
            OK
          </button>
        </div>
      </Modal>
    );
  }
}

SavingModal.displayName = 'SavingModal';
